import { apiCall } from 'app/shared/lib/essette-api';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { autoinject } from 'aurelia-framework';
import { CaseService } from 'app/cm/services/case-service';
import { Toaster } from 'app/shared/lib/toaster';
import { I18N } from 'aurelia-i18n';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class SaveReferralTypeCustomElement extends ComponentBase implements IForm {
    ////****************** Fields and Properties ************************************////
    protected isValid: boolean = false;

    public referralType?: CM.ReferralType;

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: CaseService,
        private readonly toaster: Toaster,
        private readonly i18n: I18N,
        ...rest: any[]) {
        super(...rest);
    }

    ////****************** IForm ****************************************************////
    public hasChanges(): boolean {
        throw new Error('Method not implemented.');
    }

    public async submit(): Promise<boolean> {
        const response = await this.saveReferralType();
        this.reset();
        return response;

    }

    ////****************** Functions ***********************************************////

    public reset() {
        this.referralType = {};
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    public async saveReferralType(): Promise<boolean> {
        if(!this.referralType) return false;
        let isSuccessful = false;
        let errorMessage: string = "";
        let duplicateRecord: boolean = false;

        try {
            this.state.beginSave();
            const response = await this.service.saveReferralType(this.referralType);
            isSuccessful = response.isSuccessful;
            return isSuccessful;
        } catch(error) {
            if(error.description) { errorMessage = error.description; }
            duplicateRecord = error.status.errors.some((err: any) => err.code === 'property.constraintViolated');
            throw error;
        } finally {
            if(isSuccessful) {
                if(this.referralType.id) {
                    this.toaster.standard.updated('cm:referral.type.$', isSuccessful);
                } else {
                    this.toaster.standard.created('cm:referral.type.$', isSuccessful);
                }
            } else {
                if(duplicateRecord) {
                    if(this.referralType.id) {
                        this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.update_error', { what: this.i18n.tr('cm:referral.type.code.$long'), item: this.i18n.tr('cm:referral.type.$') })).show();
                    } else {
                        this.toaster.error().message(this.i18n.tr('ui:messages.duplicate.create_error', { what: this.i18n.tr('cm:referral.type.code.$long'), item: this.i18n.tr('cm:referral.type.$') })).show();
                    }
                } else {
                    const exception = (this.toaster.toast())
                        .title('Error')
                        .class('ess-toast-error')
                        .icon('ui:icons.error')
                        .message(errorMessage)
                    exception.show();
                }
            }
            this.state.endSave();
        }

    }
}
